// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3y94p","left":"styles_left__2fePr","right":"styles_right__3-78B","alert":"styles_alert__2dHte"};